// ✅ Refactor de interfaz: separar creación/edición de Bots fuera de SettingsMulti
// Estructura propuesta (3 archivos nuevos) + parche rápido a SettingsMulti
// ├─ src/components/bots/useBotsApi.js
// ├─ src/components/bots/BotForm.jsx
// └─ src/components/bots/BotsPanel.jsx
// y en SettingsMulti.jsx: reemplazar <BotManager/> por <BotsPanel/>


// -----------------------------------------------------------------------------
// src/components/bots/useBotsApi.js
// Capa del API exclusivamente para Bots (CRUD + activar/desactivar)
// -----------------------------------------------------------------------------
import api from "../../auth/api";


export function useBotsApi() {
    const noStore = { headers: { "Cache-Control": "no-store", "Pragma": "no-cache", "If-Modified-Since": "0" } };
    const bust = () => `?_=${Date.now()}`;


    const req = {
        get: (url) => api.get(`${url}${bust()}`, noStore),
        post: (url, body) => api.post(url, body, noStore),
        put: (url, body) => api.put(url, body, noStore),
        del: (url) => api.delete(url, noStore),
    };


    const normalizeBot = (b = {}) => ({
        id: b.id,
        name: b.name || "(sin nombre)",
        kind: b.kind || "generic",
        base_url: b.base_url || "",
        webhook_path: b.webhook_path || "",
        auth_type: b.auth_type || "none", // none|basic|bearer
        basic_user: b.basic_user || "",
        basic_pass: b.basic_pass || "",
        bearer_token: b.bearer_token || "",
        is_active: !!(b.is_active ?? 1),
        created_at: b.created_at,
    });


    return {
        async list() {
            const { data } = await req.get("/bots");
            const rows = data?.rows || data?.bots || [];
            return rows.map(normalizeBot);
        },
        async create(payload) {
            const { data } = await req.post("/bots", payload);
            return normalizeBot(data?.bot || data);
        },
        async update(id, payload) {
            const { data } = await req.put(`/bots/${id}`, payload);
            return normalizeBot(data?.bot || data);
        },
        async remove(id) {
            await req.del(`/bots/${id}`);
        },
        async toggleActive(id, is_active) {
            const { data } = await req.post(`/bots/${id}/active`, { is_active: !!is_active });
            return normalizeBot(data?.bot || data);
        },
    };
}
